import sum from './sum'

const items = [
  {
    name: 'bottles',
    label: 'Bottles',
    description: "It's normal to have anywhere from 2-10 bottles per child, each bottle averaging around $10.",
    enabled: true,
    value: 50,
  },
  {
    name: 'highchair',
    label: 'Highchair',
    description: 'Highchairs typically range anywhere from $50-$200.',
    enabled: true,
    value: 100,
  },
  {
    name: 'breastPump',
    label: 'Breast pump',
    description: 'Breast pumps typically range anywhere from $50-$200.',
    enabled: true,
    value: 100,
  },
]


export default {
  name: 'feeding',
  label: 'Feeding',
  enabled: false,
  value: sum(items),
  on: false,
  items,
}
